import { createFileRoute, redirect } from '@tanstack/react-router'

import { ApiCaller } from '@graphit/callers'

import { cartographiesQueryOptions } from '~/queries/cartographies'
import { meQueryOptions } from '~/queries/me'

export const Route = createFileRoute('/_authed/cartographies/')({
	loader: async ({ context }) => {
		const [cartographies, me] = await Promise.all([
			context.queryClient.ensureQueryData(cartographiesQueryOptions),
			context.queryClient.ensureQueryData(meQueryOptions)
		])

		if (cartographies.length > 0) {
			const lastId = me.lastViewedCartographyId
			const target = (lastId && cartographies.find(c => c.id === lastId)) || cartographies[0]
			throw redirect({ to: '/cartographies/$id/classic', params: { id: target.id } })
		}

		const cartography = await ApiCaller.createCartography('Nouvelle cartographie')
		context.queryClient.setQueryData(cartographiesQueryOptions.queryKey, [cartography])
		throw redirect({ to: '/cartographies/$id/classic', params: { id: cartography.id } })
	}
})
